var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pd20x flex1"},[_c('div',{staticClass:"h100pct ofA"},[(_vm.tagsId)?_c('div',[_c('questionList',{attrs:{"id":_vm.tagsId,"type":_vm.typeList[_vm.typeIndex].type}})],1):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }